module.exports = __webpack_public_path__ + "img/logo.93509e4b.png";